// Kennisbank-artikelen: informatieve content die zoekintentie afdekt en
// intern linkt naar de dienstpagina's (money pages). Geen prijzen: prijs op aanvraag.
export const kennisbank = [
  {
    slug: "badkamer-renovatie-kosten",
    title: "Badkamer renovatie kosten: waarvan hangt de prijs af?",
    seoTitle: "Badkamer Renovatie Kosten — Waarvan hangt de prijs af?",
    description: "Wat kost een badkamer verbouwen? Ontdek de 8 factoren die de prijs van een badkamer renovatie bepalen en hoe u een eerlijke vaste prijs krijgt.",
    service: "badkamer-renovatie",
    updated: "2026-09-10",
    intro: [
      "'Wat kost een badkamer renovatie?' is de meest gestelde vraag die wij krijgen — en tegelijk de vraag die niemand eerlijk kan beantwoorden zonder de badkamer gezien te hebben. Twee badkamers van 6 m² kunnen sterk in prijs verschillen, puur door de staat van de leidingen, de indeling en de gekozen materialen.",
      "In dit artikel leggen we uit welke factoren de kosten van een badkamer verbouwing bepalen, waar u op moet letten bij het vergelijken van offertes en waarom een vaste totaalprijs na opname u het meeste zekerheid geeft.",
    ],
    sections: [
      {
        heading: "1. Oppervlakte en indeling",
        paragraphs: [
          "De oppervlakte bepaalt de hoeveelheid tegelwerk, maar de indeling weegt vaak zwaarder. Blijven douche, toilet en wastafel op dezelfde plek, dan is het leidingwerk beperkt. Verplaatst u het toilet of de douche, dan moeten afvoer en waterleidingen worden verlegd — soms door de vloer of naar een andere standleiding. Een gewijzigde indeling vraagt daardoor meer uren van de loodgieter en soms constructief werk.",
        ],
      },
      {
        heading: "2. De leeftijd en staat van uw woning",
        paragraphs: [
          "Dit is de grootste onzekerheid in veel offertes. In woningen van vóór 1970 treffen we regelmatig verouderde loden of stalen leidingen, houten vloeren met ongelijke ondergrond en afvoeren zonder goed afschot. Die moeten worden vervangen of hersteld voordat er een tegel geplaatst wordt. In nieuwere woningen is dat zelden nodig.",
          "Een goede aannemer beoordeelt dit tijdens de opname en legt vast wat wel en niet in de prijs zit. Zo voorkomt u dat 'onvoorzien werk' halverwege de verbouwing de rekening opdrijft.",
        ],
      },
      {
        heading: "3. Sanitair en kranen",
        paragraphs: [
          "Het verschil tussen een degelijk A-merk hangtoilet en een designuitvoering met bijpassende bedieningsplaat, of tussen een standaard thermostaatkraan en een regendouche met inbouwthermostaat, is aanzienlijk. Kies bewust: sanitair dat u dagelijks aanraakt (kraan, douche) verdient meestal het hoogste budget; onderdelen die u niet ziet (inbouwreservoir) moeten vooral betrouwbaar zijn.",
        ],
      },
      {
        heading: "4. Tegelwerk: formaat, patroon en snijwerk",
        paragraphs: [
          "Grootformaat tegels (60×120 cm en groter) geven een rustig beeld met weinig voegen, maar vragen een perfect vlakke ondergrond en precisie bij het zagen. Kleine formaten of een visgraatpatroon vragen juist veel meer uren zetwerk. Ook het aantal hoeken, nissen en leidingdoorvoeren bepaalt hoeveel snijwerk er nodig is.",
        ],
      },
      {
        heading: "5. Vloerverwarming, ventilatie en elektra",
        paragraphs: [
          "Vloerverwarming is inmiddels standaard in een nieuwe badkamer en vraagt een eigen groep en thermostaat. Een mechanische ventilatiebox voorkomt schimmel en is in oudere woningen vaak nog niet aanwezig. Extra spots, spiegelverlichting, een scheerstopcontact en een designradiator vragen elk hun eigen aansluiting.",
        ],
      },
      {
        heading: "6. Constructieve ingrepen",
        paragraphs: [
          "Wilt u een aparte douche en toilet samenvoegen, een muur verplaatsen of een raam laten dichtzetten? Dan komt er sloop- en constructiewerk bij, en soms een vergunning. Dit soort ingrepen verdient een aparte post in de offerte.",
        ],
      },
      {
        heading: "7. Sloop, afvoer en herstel",
        paragraphs: [
          "Strippen van de oude badkamer, afvoeren van puin naar de milieustraat en herstellen van wanden en plafond zijn kostenposten die in een goede offerte expliciet benoemd staan. In appartementen komen daar soms afspraken met de VvE bij over werktijden en transport door het trappenhuis.",
        ],
      },
      {
        heading: "8. Wie voert het werk uit?",
        paragraphs: [
          "Een badkamer vraagt minimaal drie disciplines: loodgieter, elektricien en tegelzetter. Werkt een aannemer met losse onderaannemers, dan betaalt u indirect voor wachttijd en coördinatie. Werken deze vakmensen als één vast team, dan is de doorlooptijd korter en ontstaan er minder fouten op de overgangen tussen disciplines.",
        ],
      },
      {
        heading: "Waarom wij geen 'vanaf-prijs' noemen",
        paragraphs: [
          "Vanaf-prijzen op websites zijn vrijwel altijd gebaseerd op de gunstigste situatie: kleine badkamer, nieuwe woning, bestaande indeling, basis sanitair. In de praktijk klopt dat zelden, en het eindbedrag valt hoger uit. Wij kiezen daarom voor een gratis opname bij u thuis, waarna u één vaste totaalprijs krijgt waarin alles is inbegrepen.",
        ],
        bullets: [
          "Vergelijk offertes altijd op wat er wél en niet is inbegrepen",
          "Vraag hoe de aannemer omgaat met onvoorziene zaken achter de tegels",
          "Controleer of sloop, afvoer, elektra en ventilatie expliciet zijn opgenomen",
          "Vraag wie het werk uitvoert: eigen team of onderaannemers",
        ],
      },
    ],
    faqs: [
      { q: "Kunnen jullie een prijsindicatie geven zonder opname?", a: "Wij geven liever geen indicatie zonder de badkamer gezien te hebben, omdat de staat van leidingen en ondergrond de prijs sterk beïnvloedt. De opname is gratis en leidt tot een vaste totaalprijs." },
      { q: "Is een vaste prijs echt vast?", a: "Ja. Wat we tijdens de opname vastleggen als inbegrepen, is inbegrepen. Alleen wijzigingen die u zelf tijdens het project aanvraagt, worden vooraf schriftelijk als meerwerk vastgelegd." },
      { q: "Wat is de goedkoopste manier om een badkamer te vernieuwen?", a: "De bestaande indeling behouden. Dan blijft het leidingwerk beperkt en gaat het budget naar zichtbare onderdelen: tegels, sanitair en kranen." },
    ],
  },
  {
    slug: "kleine-badkamer-verbouwen",
    title: "Kleine badkamer verbouwen: 9 slimme ideeën voor meer ruimte",
    seoTitle: "Kleine Badkamer Verbouwen — 9 slimme ideeën voor meer ruimte",
    description: "Een kleine badkamer verbouwen? Met een inloopdouche, hangtoilet en de juiste tegels wint u ruimte. 9 praktische tips van een badkamerspecialist.",
    service: "badkamer-renovatie",
    updated: "2026-09-10",
    intro: [
      "Veel woningen in Zuid-Holland — van jaren '30-huizen in Den Haag en Schiedam tot portiekwoningen in Rotterdam — hebben een badkamer van 3 tot 5 m². Klein, maar met de juiste keuzes kan zo'n ruimte aanvoelen als een volwaardige badkamer.",
      "Hieronder delen we negen ideeën die wij in de praktijk toepassen bij het verbouwen van kleine badkamers, van indeling tot tegelkeuze en verlichting.",
    ],
    sections: [
      {
        heading: "1. Kies een inloopdouche zonder cabine",
        paragraphs: [
          "Een douchecabine met deuren neemt visueel en fysiek ruimte in. Een inloopdouche met één glazen wand en een lijngoot maakt de vloer één vlak en laat de badkamer groter lijken. Reken op minimaal 90 cm breedte voor comfort; met 100 cm doucht u royaal.",
        ],
      },
      {
        heading: "2. Hangtoilet met inbouwreservoir",
        paragraphs: [
          "Een hangtoilet met inbouwreservoir wint diepte ten opzichte van een staand toilet en maakt de vloer vrij, wat schoonmaken makkelijker maakt. Bovenop het inbouwreservoir ontstaat een handige plank voor opbergen.",
        ],
      },
      {
        heading: "3. Smalle of hoekwastafel met meubel",
        paragraphs: [
          "Wastafelmeubels zijn er in dieptes vanaf circa 35 cm. Een hangend meubel met lades biedt opbergruimte zonder de ruimte dicht te zetten. In heel krappe badkamers kan een hoekwastafel een oplossing zijn.",
        ],
      },
      {
        heading: "4. Grootformaat tegels en doorlopende vloer",
        paragraphs: [
          "Tegenintuïtief, maar grote tegels maken een kleine ruimte rustiger: minder voegen, minder visuele ruis. Laat de vloertegel doorlopen in de douche en kies wand- en vloertegels in dezelfde kleurfamilie voor een naadloos gevoel.",
        ],
      },
      {
        heading: "5. Lichte kleuren, één accent",
        paragraphs: [
          "Lichte tegels reflecteren licht en verruimen. Wilt u karakter, kies dan één accent — een nis met kleur, een zwarte kraan of een houtlook wastafelmeubel — in plaats van meerdere drukke elementen.",
        ],
      },
      {
        heading: "6. Nissen in plaats van rekjes",
        paragraphs: [
          "Een ingebouwde nis in de douchewand houdt shampoo en zeep uit het zicht zonder een rek dat ruimte inneemt. Wij metselen of frezen de nis tijdens het leidingwerk uit, voordat het tegelwerk begint.",
        ],
      },
      {
        heading: "7. Spiegel over de volle breedte met verlichting",
        paragraphs: [
          "Een grote spiegel verdubbelt de ruimte optisch. Kies een spiegel met geïntegreerde ledverlichting, zodat u geen aparte wandlampen nodig heeft die ruimte innemen.",
        ],
      },
      {
        heading: "8. Douche en toilet samenvoegen",
        paragraphs: [
          "In veel jaren '60- en '70-woningen liggen een aparte doucheruimte en toilet naast elkaar. Door de tussenwand te verwijderen ontstaat één badkamer met ruimte voor een inloopdouche, hangtoilet en wastafel. Dit is een van de meest effectieve ingrepen bij een kleine badkamer.",
        ],
      },
      {
        heading: "9. Vloerverwarming in plaats van een radiator",
        paragraphs: [
          "Een radiator neemt wandruimte in. Met vloerverwarming is de badkamer comfortabel warm zonder verwarmingselement aan de muur. Wilt u toch handdoeken drogen, kies dan een smalle designradiator boven het toilet.",
        ],
      },
      {
        heading: "Hoe wij een kleine badkamer aanpakken",
        paragraphs: [
          "Tijdens een gratis opname meten we de badkamer in, bekijken we leidingen en afvoer en tekenen we de indeling met u uit. Daarna ontvangt u een vaste prijs. Omdat onze loodgieter, elektricien en tegelzetter in één team werken, is de uitvoering van een kleine badkamer meestal binnen twee weken gereed.",
        ],
      },
    ],
    faqs: [
      { q: "Past een inloopdouche in een badkamer van 4 m²?", a: "In de meeste gevallen wel. Met een inloopdouche van 90–100 cm breed, een hangtoilet en een smalle wastafel is 4 m² voldoende voor een complete badkamer." },
      { q: "Kan een bad in een kleine badkamer?", a: "Een bad vraagt minimaal 160–170 cm lengte en circa 70 cm breedte. In badkamers onder 5 m² gaat dat meestal ten koste van een comfortabele douche. Vaak adviseren we dan een royale inloopdouche." },
      { q: "Hoe lang duurt het verbouwen van een kleine badkamer?", a: "Een kleine badkamer verbouwen wij doorgaans binnen circa twee weken, van sloop tot oplevering." },
    ],
  },
  {
    slug: "badkamer-verbouwen-stappenplan",
    title: "Badkamer verbouwen: stappenplan van opname tot oplevering",
    seoTitle: "Badkamer Verbouwen Stappenplan — van opname tot oplevering",
    description: "Uw badkamer laten verbouwen? Dit stappenplan laat zien hoe een badkamer renovatie verloopt: opname, vaste prijs, materiaalkeuze, sloop, leidingwerk, tegelwerk en oplevering.",
    service: "badkamer-renovatie",
    updated: "2026-09-10",
    intro: [
      "Een badkamer verbouwen is een project met veel onderdelen die precies op elkaar moeten aansluiten: sloop, loodgieterswerk, elektra, waterdichting, tegelwerk en afmontage. Weet u vooraf hoe het traject verloopt, dan kunt u zich goed voorbereiden en vragen stellen op het juiste moment.",
      "Dit is het stappenplan zoals wij het bij elke badkamer renovatie doorlopen.",
    ],
    sections: [
      {
        heading: "Stap 1 — Gratis opname bij u thuis",
        paragraphs: [
          "We meten de badkamer in, bekijken de staat van leidingen, afvoer, vloer en ventilatie en bespreken uw wensen: indeling, inloopdouche of bad, vloerverwarming, tegels en sanitair. Juist bij oudere woningen is deze stap cruciaal, omdat hier bepaald wordt wat er achter de tegels moet gebeuren.",
        ],
      },
      {
        heading: "Stap 2 — Vaste totaalprijs",
        paragraphs: [
          "Op basis van de opname ontvangt u één vaste prijs waarin sloop, leidingwerk, elektra, tegelwerk, sanitairmontage en afwerking zijn opgenomen. We leggen vast wat inbegrepen is en wat we verwachten aan te treffen, zodat er tijdens de uitvoering geen discussie ontstaat.",
        ],
      },
      {
        heading: "Stap 3 — Materiaalkeuze en bestelling",
        paragraphs: [
          "U kiest tegels, sanitair en kranen; wij adviseren over maatvoering, kwaliteit en combinaties en bestellen alles. Tegels en sanitair hebben levertijd. Wij plannen de start pas als alle materialen binnen zijn, zodat het werk niet stil komt te liggen.",
        ],
        bullets: [
          "Tegels: formaat, kleur, antislip voor de vloer",
          "Sanitair: hangtoilet, wastafel(meubel), douche of bad",
          "Kranen en douchesysteem",
          "Verlichting, spiegel, radiator en accessoires",
        ],
      },
      {
        heading: "Stap 4 — Sloop en leidingwerk (dag 1–3)",
        paragraphs: [
          "De oude badkamer wordt gestript tot op de ondergrond en het puin wordt afgevoerd. Onze loodgieter legt nieuwe water- en afvoerleidingen, de elektricien brengt groepen aan voor vloerverwarming, spots en stopcontacten. Waar nodig herstellen we de ondergrond.",
        ],
      },
      {
        heading: "Stap 5 — Waterdichting en vloerverwarming",
        paragraphs: [
          "Tegels zijn niet waterdicht; de laag eronder wel. We brengen een waterdichte coating of folie aan op vloer en spatzones en leggen de vloerverwarming. Dit is de stap die bepaalt of uw badkamer over vijftien jaar nog lekvrij is.",
        ],
      },
      {
        heading: "Stap 6 — Tegelwerk (dag 4–8)",
        paragraphs: [
          "Onze tegelzetter zet vloer en wanden, inclusief nissen, afschot naar de douchegoot en strakke voegen. Bij grootformaat tegels komt het aan op een vlakke ondergrond en precisie in het zaagwerk.",
        ],
      },
      {
        heading: "Stap 7 — Afmontage (dag 9–10)",
        paragraphs: [
          "Hangtoilet, wastafel, kranen, douchewand, radiator, spiegel en verlichting worden gemonteerd. Alle aansluitingen worden gekit en getest op lekkage. De ventilatie wordt aangesloten en ingeregeld.",
        ],
      },
      {
        heading: "Stap 8 — Oplevering",
        paragraphs: [
          "We lopen de badkamer samen met u na, controleren alle functies en maken schoon. U ontvangt de documentatie van het gebruikte sanitair. Pas als u tevreden bent, is het project afgerond.",
        ],
      },
      {
        heading: "Waarom één vast team het verschil maakt",
        paragraphs: [
          "Bij een badkamer wisselen de disciplines elkaar dagelijks af. Werken loodgieter, elektricien en tegelzetter als één team, dan sluit de planning naadloos aan en is een standaard badkamer in circa twee weken gereed. Werkt een aannemer met losse onderaannemers, dan loopt een project al snel uit door wachttijd tussen de partijen.",
        ],
      },
    ],
    faqs: [
      { q: "Moet ik zelf materialen kopen?", a: "Nee. U kiest de materialen, wij adviseren en bestellen alles en stemmen de levering af op de planning." },
      { q: "Kan ik tijdens de verbouwing thuis blijven wonen?", a: "Ja. De badkamer is circa twee weken niet bruikbaar; het toilet proberen we zo lang mogelijk beschikbaar te houden. We denken graag mee over een tijdelijke oplossing." },
      { q: "Heb ik een vergunning nodig voor een badkamer renovatie?", a: "Voor een renovatie op de bestaande plek meestal niet. Verandert de constructie (dragende wand, nieuwe raamopening) of woont u in een monument, dan kan een vergunning nodig zijn. Wij adviseren u hierover tijdens de opname." },
    ],
  },
  {
    slug: "inloopdouche-plaatsen",
    title: "Inloopdouche laten plaatsen: afmetingen, afvoer en aandachtspunten",
    seoTitle: "Inloopdouche Laten Plaatsen — afmetingen, afvoer & tips",
    description: "Een inloopdouche laten plaatsen? Lees welke afmetingen u nodig heeft, hoe de afvoer en waterdichting werken en welke keuzes u vooraf maakt.",
    service: "badkamer-renovatie",
    updated: "2026-09-10",
    intro: [
      "De inloopdouche is de populairste keuze bij een badkamer renovatie: drempelloos, ruimtelijk en makkelijk schoon te houden. Maar een goede inloopdouche is meer dan een glazen wand. Afschot, afvoer, waterdichting en maatvoering bepalen of de douche over jaren nog lekvrij en comfortabel is.",
      "In dit artikel leest u waar u op moet letten als u een inloopdouche laat plaatsen, of dat nu onderdeel is van een complete badkamer renovatie of een losse ingreep.",
    ],
    sections: [
      {
        heading: "Welke afmetingen heeft een inloopdouche nodig?",
        paragraphs: [
          "Voor comfort adviseren we minimaal 90 cm breedte en 100 cm lengte; vanaf 100 × 120 cm doucht u royaal zonder dat water de rest van de badkamer bereikt. De glazen wand is meestal 90 tot 120 cm breed en 200 cm hoog. In kleine badkamers kan een inloopdouche in een nis of hoek de oplossing zijn.",
        ],
      },
      {
        heading: "Afschot en douchegoot",
        paragraphs: [
          "Water moet naar de afvoer stromen zonder plassen achter te laten. We werken met 1,5 tot 2% afschot richting een lijngoot (tegen de wand of in het midden) of een puntafvoer. Een lijngoot tegen de achterwand laat de vloertegels in één richting doorlopen — visueel het mooiste resultaat. De afvoer heeft voldoende diameter en een goede hellingshoek nodig; in oudere woningen vervangen we de afvoer vaak.",
        ],
      },
      {
        heading: "Waterdichting: de onzichtbare basis",
        paragraphs: [
          "Tegels en voegen zijn niet waterdicht. Onder het tegelwerk brengen we een waterdichte laag aan (coating of folie) die doorloopt in de hoeken, rond de goot en op de spatzones van de wanden. Dit is de belangrijkste stap van de hele inloopdouche — en de stap die het vaakst wordt overgeslagen bij goedkope uitvoeringen.",
        ],
      },
      {
        heading: "Vloertegels: antislip en formaat",
        paragraphs: [
          "Kies in de douche een vloertegel met antislipklasse (R10 of R11) of een mozaïek dat het afschot volgt. Grootformaat tegels kunnen in de douche worden toegepast, mits ze goed onder afschot worden gezet; soms kiezen we voor een iets kleiner formaat in de douchezone.",
        ],
      },
      {
        heading: "Douchesysteem en thermostaat",
        paragraphs: [
          "Een inbouwthermostaat met regendouche en handdouche geeft het strakste beeld: alleen de bedieningsknoppen en de douchekop zijn zichtbaar. Een opbouwsysteem is eenvoudiger te installeren en te onderhouden. Beide vragen goed leidingwerk op de juiste hoogte, wat we tijdens de ruwbouw vastleggen.",
        ],
      },
      {
        heading: "Ventilatie",
        paragraphs: [
          "Een open inloopdouche brengt meer vocht in de badkamer dan een gesloten cabine. Een mechanische ventilatiebox, eventueel vochtgestuurd, voorkomt schimmel en condens. Bij oudere woningen zonder mechanische ventilatie nemen we dit standaard mee.",
        ],
      },
      {
        heading: "Losse inloopdouche of complete badkamer?",
        paragraphs: [
          "Een inloopdouche los plaatsen kan, maar omdat de vloer open moet voor afschot en afvoer en de wand voor het leidingwerk, wordt het tegelwerk meestal toch grotendeels vernieuwd. Vaak is een complete badkamer renovatie daardoor de logischere en uiteindelijk voordeligere keuze. Tijdens een gratis opname adviseren we eerlijk wat in uw situatie zinvol is.",
        ],
      },
    ],
    faqs: [
      { q: "Kan een inloopdouche zonder glazen wand?", a: "Ja, bij voldoende diepte (vanaf circa 140–150 cm) kan een inloopdouche zonder glaswand. Bij kleinere afmetingen adviseren we een enkele glazen wand om spatwater te beperken." },
      { q: "Is een inloopdouche geschikt als ik ouder word?", a: "Juist wel. Een drempelloze douche is veilig en toegankelijk. Combineer met een antislipvloer, een zitje en eventueel beugels. In sommige gemeenten is een aanpassing via de Wmo mogelijk." },
      { q: "Hoe lang duurt het plaatsen van een inloopdouche?", a: "Als onderdeel van een complete badkamer renovatie is de uitvoering in circa twee weken gereed. Een losse inloopdouche duurt korter, afhankelijk van de hoeveelheid tegelwerk en leidingwerk." },
    ],
  },
];

export const findArticle = (slug) => kennisbank.find((a) => a.slug === slug);
export const articlesForService = (serviceSlug) => kennisbank.filter((a) => a.service === serviceSlug);
